var map = {
	"./amex.png": 1022,
	"./diners.png": 1023,
	"./discover.png": 1024,
	"./jcb.png": 1025,
	"./maestro.png": 1254,
	"./mastercard.png": 1026,
	"./stripe.png": 1027,
	"./union.png": 1028,
	"./unknown.png": 706,
	"./visa.png": 1029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1253;